import { IntegrationLog } from '../../types';
import IconArrowDiagonal from '../../../icons/arrow-diagonal';
import formatDate from '../../../../helpers/format-date';
import IconClock from '../../../icons/clock';
import IconSelected from '../../../icons/selected';
import IconCopyTwo from '../../../icons/copy-two';

import styles from '../styles.module.css';

const formatIntegrationLogs = (
  list: IntegrationLog[],
  onCopy: (text: string) => void,
  copyIsSuccess?: boolean,
): IntegrationLog[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    let statusCodeClassName = '';
    let responseTimeClassName = '';
    let type;

    if (item?.statusCode) {
      if (item?.statusCode?.toString()?.charAt(0) === '2') {
        statusCodeClassName = styles.successStatus;
      } else if (item?.statusCode?.toString()?.charAt(0) === '3') {
        statusCodeClassName = styles.redirectStatus;
      } else if (item?.statusCode?.toString()?.charAt(0) === '4') {
        statusCodeClassName = styles.errorStatusCode;
      } else if (item?.statusCode?.toString()?.charAt(0) === '5') {
        statusCodeClassName = styles.internalErrorStatusCode;
      }
    }

    if (item?.requestTime && item?.responseTime) {
      const difference =
        new Date(item?.responseTime).getTime() -
        new Date(item.requestTime).getTime();

      if (difference >= 1500 && difference <= 2500) {
        responseTimeClassName = styles.yellowIcon;
      } else if (difference > 2500) {
        responseTimeClassName = styles.redIcon;
      }
    } else if (!item.responseTime) {
      responseTimeClassName = styles.redIcon;
    }

    if (item?.type) {
      type = (
        <div className={styles.logType}>
          <IconArrowDiagonal
            width={10}
            height={10}
            className={item?.type === 'WEBHOOK' ? styles.webhookIcon : ''}
          />
          {`${item?.type?.charAt(0)}${item?.type?.slice(1).toLowerCase()}`}
        </div>
      );
    } else {
      type = '-';
    }

    const render: Record<string, React.JSX.Element> = {
      type: <div>{type}</div>,
      url: (
        <div className={styles.urlEventTypeWrapper}>
          {item?.eventType && (
            <div className={styles.listEventTypeWrapper}>
              <div className={styles.eventType}>{item.eventType}</div>
            </div>
          )}
          {item?.url && (
            <div className={styles.logUrl}>
              <span>{item.url}</span>
            </div>
          )}
          {!item?.eventType && !item?.url && '-'}
        </div>
      ),
      requestTime: (
        <div>
          {item?.requestTime ? formatDate(item.requestTime, true, true) : '-'}
        </div>
      ),
      responseTime: (
        <div className={styles.logsResponseTime}>
          {item?.responseTime ? formatDate(item.responseTime, true, true) : '-'}
          <div className={styles.logsResponseTimeIcon}>
            <div className={styles.logsResponseLatency}>{`Latency: ${
              item?.requestTime && item?.responseTime
                ? new Date(item?.responseTime).getTime() -
                  new Date(item.requestTime).getTime()
                : '-'
            } ms`}</div>
            <IconClock
              width={14}
              height={14}
              className={responseTimeClassName}
            />
          </div>
        </div>
      ),
      statusCode: (
        <div>
          {item?.statusCode ? (
            <div className={`${styles.logStatusCode} ${statusCodeClassName}`}>
              {item.statusCode}
            </div>
          ) : (
            '-'
          )}
        </div>
      ),
      responseBody: (
        <div className={styles.logsResponseBodyWrapper}>
          <div className={styles.logsResponseBody}>
            <span>{item?.responseBody || '-'}</span>
          </div>
          <button
            type="button"
            className={styles.copyListButton}
            onClick={() =>
              onCopy(
                item?.responseBody
                  ? JSON.stringify(
                      item?.responseBody.includes('{') &&
                        item?.responseBody.charAt(0) === '{'
                        ? JSON.parse(item?.responseBody)
                        : item?.responseBody,
                      null,
                      2,
                    )
                  : '-',
              )
            }
          >
            {copyIsSuccess ? (
              <IconSelected />
            ) : (
              <IconCopyTwo width={16} height={16} />
            )}
          </button>
        </div>
      ),
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatIntegrationLogs;
